import { forwardRef } from "react";

import type {
  TTableSectionProps,
} from "@/ui/components/data-display/Table/Table.config";
import { cn } from "@/ui/lib/utils";

export const THead = forwardRef<HTMLTableSectionElement, TTableSectionProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <thead
      {...props}
      ref={ref}
      data-component="THead"
      className={cn(className)}
    />
  ),
);

THead.displayName = "THead";
